import React, { useContext } from 'react'
import PropTypes from 'prop-types'

const PagePropertiesContext = React.createContext({})

export const PagePropertiesProvider = ({ pageProperties, children }) => {
  return (
    <PagePropertiesContext.Provider value={pageProperties}>
      {children}
    </PagePropertiesContext.Provider>
  )
}

PagePropertiesProvider.propTypes = {
  pageProperties: PropTypes.object,
  children: PropTypes.node,
}

export const usePageProperties = () => {
  return useContext(PagePropertiesContext)
}
